import { lazy } from 'react';
export var TeamProfileCardLazy = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_lazy-team-profilecard" */
  './TeamProfileCard');
});